import { Farm } from './farm';
export class Device {
  id?: number;
  code?: string;
  description?: string;
  type?: string;
  lat?: number;
  lng?: number;
  farm?: Farm;
  dateCreated?: Date;
  deviceType?: string;
  configurationParameters?: any;

  constructor() {
    this.code = null;
    this.description = null;
    this.type = 'multi';
    this.lat = null;
    this.lng = null;
    this.farm = null;
    this.dateCreated = null;
    this.deviceType = null;
    this.configurationParameters = [];
  }
}

/*
*********** MODELLO DI BACKEND **********************
package com.xfarm.api.v1.xsense

import com.xfarm.api.v1.core.Farm

class Device {

    string  code
    string  description
    string  type = 'multi'
    Double  lat
    Double  lng

    static belongsTo      = [farm: Farm]

    static constraints = {
        code            blank: false, nullable: false
        description     blank: false, nullable: true
        type            blank: false, nullable: false, inList: ['multi']
        lat             nullable: false
        lng             nullable: false
    }
}


*/
